// extracted by mini-css-extract-plugin
export default {"content":"MeusMTR_content__g7Fhd","loading":"MeusMTR_loading__O8yBx"};